<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="OT">Contents</p>
<p class="CON1"><a href="#/CoverImage">Cover</a></p>
<p class="CON1"><a href="#/Dedication">Dedication</a></p>
<p class="CON1" id="toc1"><a href="#/Brothers_Distance_in_Preaching_text2#toc_marker-3">1. Setting the Stage</a></p>
<p class="CON2" id="toc2"><a href="#/Brothers_Distance_in_Preaching_text2#toc_marker-3-1">A Change in Hearing</a></p>
<p class="CON2" id="toc3"><a href="#/Brothers_Distance_in_Preaching_text2#toc_marker-3-2">Proposal and Plan of the Book</a></p>
<p class="CON2" id="toc4"><a href="#/Brothers_Distance_in_Preaching_text2#toc_marker-3-3">Introducing Distance in Preaching</a></p>
<p class="CON1" id="toc5"><a href="#/Brothers_Distance_in_Preaching_text3#toc_marker-4">2. Aesthetic Distance in Performance</a></p>
<p class="CON2" id="toc6"><a href="#/Brothers_Distance_in_Preaching_text3#toc_marker-4-1">Aesthetic Distance</a></p>
<p class="CON2" id="toc7"><a href="#/Brothers_Distance_in_Preaching_text3#toc_marker-4-2">Performing Distance</a></p>
<p class="CON2" id="toc8"><a href="#/Brothers_Distance_in_Preaching_text3#toc_marker-4-3">Backdrop for Preaching</a></p>
<p class="CON1" id="toc9"><a href="#/Brothers_Distance_in_Preaching_text4#toc_marker-5">3. Distance in Preaching:Fred Craddock’s Homiletical Method</a></p>
<p class="CON2" id="toc10"><a href="#/Brothers_Distance_in_Preaching_text4#toc_marker-5-1">Preserving the Text: Distance in Interpretation</a></p>
<p class="CON2" id="toc11"><a href="#/Brothers_Distance_in_Preaching_text4#toc_marker-5-2">Protecting the Hearer: Distance in the Sermon</a></p>
<p class="CON2" id="toc12"><a href="#/Brothers_Distance_in_Preaching_text4#toc_marker-5-3">Respecting the Hearer: Distance in Delivery</a></p>
<p class="CON2" id="toc13"><a href="#/Brothers_Distance_in_Preaching_text4#toc_marker-5-4">Summary</a></p>
<p class="CON1" id="toc14"><a href="#/Brothers_Distance_in_Preaching_text5#toc_marker-6">4. Absorption in the Sermon:Postliberal Homiletics</a></p>
<p class="CON2" id="toc15"><a href="#/Brothers_Distance_in_Preaching_text5#toc_marker-6-1">Mark Ellingsen’s Homiletic</a></p>
<p class="CON2" id="toc16"><a href="#/Brothers_Distance_in_Preaching_text5#toc_marker-6-2">Charles Campbell’s Homiletic</a></p>
<p class="CON2" id="toc17"><a href="#/Brothers_Distance_in_Preaching_text5#toc_marker-6-3">Absorption Reconsidered</a></p>
<p class="CON1" id="toc18"><a href="#/Brothers_Distance_in_Preaching_text6#toc_marker-7">5. Clearing the Sanctuary: Room and Space</a></p>
<p class="CON2" id="toc19"><a href="#/Brothers_Distance_in_Preaching_text6#toc_marker-7-1">Distance Reconsidered</a></p>
<p class="CON2" id="toc20"><a href="#/Brothers_Distance_in_Preaching_text6#toc_marker-7-2">Recent Proposals</a></p>
<p class="CON2" id="toc21"><a href="#/Brothers_Distance_in_Preaching_text6#toc_marker-7-3">Conclusion</a></p>
<p class="CON1" id="toc22"><a href="#/Brothers_Distance_in_Preaching_text62#toc_marker-8">Two Sermons</a></p>
<p class="CON2" id="toc23"><a href="#/Brothers_Distance_in_Preaching_text62#toc_marker-8-1">“Were You There?”</a></p>
<p class="CON2" id="toc24"><a href="#/Brothers_Distance_in_Preaching_text62#toc_marker-8-2">“Sibling Revelry”</a></p>
<p class="CON1" id="toc25"><a href="#/Brothers_Distance_in_Preaching_text7#toc_marker-9">Bibliography</a></p>
<p class="CON1" id="toc26"><a href="#/Brothers_Distance_in_Preaching_text8#toc_marker-10">Index</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Brothers_Distance_in_Preaching_text-1.vue?dd2773a2